import TagManager from "react-gtm-module";

export const gtmEventSubmitForm = (email: string, phone: string) => {
  TagManager.dataLayer({
    dataLayer: {
      event: "form_submitted",
      form_page: window.location.href,
      form_name: "Whatsapp Pós",
      form_type: "form-whtsapp",
      email: email,
      tel: phone,
    },
  });
};
